var _linearGradient, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500.00001 500.00001",
    id: "svg4216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4218"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4843-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4853",
    offset: 0,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.56078434
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4843-5",
    id: "linearGradient4849",
    x1: -261.72736,
    y1: 609.7821,
    x2: -471.52579,
    y2: 819.51794,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.004,0,0,1.004,439.78546,-434.12407)"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4221"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-552.36216)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      color: "#000000",
      cliprule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorinterpolationfilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#fdb719",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "#060606",
      strokewidth: 2.91508746,
      strokelinecap: "butt",
      strokelinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    id: "rect4770",
    width: 360.48172,
    height: 360.48172,
    x: -570.81989,
    y: 563.8916,
    rx: 15.350842,
    transform: "matrix(0.70710678,-0.70710678,0.70710678,0.70710678,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      color: "#000000",
      cliprule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorinterpolationfilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#060606",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none",
      strokewidth: 2.62357879,
      strokelinecap: "butt",
      strokelinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    id: "rect4770-7",
    width: 333.5719,
    height: 333.5719,
    x: -557.36499,
    y: 577.3465,
    rx: 14.204907,
    transform: "matrix(0.70710679,-0.70710677,0.70710679,0.70710677,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      color: "#000000",
      cliprule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorinterpolationfilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#fdb719",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none",
      strokewidth: 2.62357879,
      strokelinecap: "butt",
      strokelinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    id: "rect4770-7-2",
    width: 319.06876,
    height: 319.06876,
    x: -550.11346,
    y: 584.59808,
    rx: 13.587301,
    transform: "matrix(0.70710678,-0.70710678,0.70710678,0.70710678,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "113.72692108px",
      lineHeight: "125%",
      fontFamily: "Consolas",
      InkscapeFontSpecification: "'Consolas, Bold'",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      display: "inline",
      fill: "#060606",
      fillOpacity: 1,
      stroke: "none",
      strokewidth: 1,
      strokelinecap: "butt",
      strokelinejoin: "miter",
      strokeOpacity: 1
    },
    id: "text4867"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 164.20507,241.61488 q 0,9.88447 -2.33229,17.04793 -2.27676,7.16346 -6.33051,11.77251 -3.99821,4.60905 -9.44022,6.83028 -5.38648,2.22123 -11.55039,2.22123 -14.32693,0 -21.54592,-9.49575 -7.21899,-9.55129 -7.21899,-27.70983 0,-9.88447 2.27676,-17.04793 2.33229,-7.16347 6.3305,-11.77252 4.05374,-4.60905 9.44022,-6.83028 5.44201,-2.22123 11.60592,-2.22123 14.32693,0 21.54592,9.49576 7.219,9.49575 7.219,27.70983 z m -14.43799,0.66637 q 0,-12.88313 -3.44291,-19.21363 -3.4429,-6.33051 -11.32826,-6.33051 -3.94269,0 -6.71922,1.66593 -2.77654,1.61039 -4.60905,4.77564 -1.77698,3.16525 -2.60995,7.82983 -0.83296,4.60905 -0.83296,10.60637 0,12.88313 3.44291,19.21363 3.49843,6.3305 11.32827,6.3305 3.94268,0 6.71921,-1.61039 2.83207,-1.66592 4.60905,-4.83117 1.77699,-3.16525 2.60995,-7.7743 0.83296,-4.66458 0.83296,-10.6619 z",
    style: {},
    id: "path4875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 224.90015,249.55577 q 0,6.66369 -1.88805,12.21676 -1.88804,5.49754 -5.44201,9.44022 -3.55396,3.94269 -8.71832,6.10838 -5.16436,2.1657 -11.77251,2.1657 -6.27498,0 -11.21721,-1.83251 -4.94223,-1.83252 -8.38514,-5.44201 -3.4429,-3.66503 -5.27542,-9.10704 -1.83251,-5.49754 -1.83251,-12.77207 0,-6.71922 1.88804,-12.21676 1.94358,-5.49754 5.49754,-9.38469 3.6095,-3.88715 8.77386,-5.99732 5.16436,-2.1657 11.66145,-2.1657 6.3305,0 11.27274,1.88805 4.94223,1.83251 8.38514,5.49754 3.4429,3.66503 5.21988,9.10704 1.83252,5.38648 1.83252,12.49441 z m -14.10481,0.33319 q 0,-8.77386 -3.33184,-13.16078 -3.27631,-4.44246 -9.71788,-4.44246 -3.55396,0 -6.05284,1.38827 -2.49889,1.38826 -4.10928,3.83162 -1.61039,2.38782 -2.38782,5.6086 -0.7219,3.22078 -0.7219,6.88581 0,8.82938 3.55397,13.32737 3.55396,4.44246 9.71787,4.44246 3.38738,0 5.88626,-1.33274 2.49888,-1.38827 4.05374,-3.77609 1.55486,-2.44335 2.33229,-5.71966 0.77743,-3.27631 0.77743,-7.0524 z",
    style: {},
    id: "path4877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 287.48327,249.00046 q 0,7.77431 -2.22123,13.43844 -2.16569,5.66413 -6.10837,9.44022 -3.88716,3.72056 -9.2181,5.55308 -5.33095,1.77698 -11.60593,1.77698 -2.11016,0 -4.22033,-0.27766 -2.11017,-0.27765 -3.83162,-0.72189 l 0,22.04569 -13.5495,0 0,-78.46491 11.71699,0 0.33318,8.32961 q 1.72145,-2.1657 3.55397,-3.94268 1.88804,-1.77699 4.05374,-2.99866 2.1657,-1.27721 4.66458,-1.94358 2.49888,-0.66637 5.6086,-0.66637 4.99777,0 8.88492,1.99911 3.88715,1.99911 6.49709,5.71967 2.66548,3.66502 4.05375,8.94044 1.38826,5.21989 1.38826,11.77251 z m -14.21586,0.55531 q 0,-4.66458 -0.66637,-7.94089 -0.66637,-3.27631 -1.94358,-5.38648 -1.22167,-2.11017 -3.05419,-3.05419 -1.77698,-0.99955 -4.10927,-0.99955 -3.4429,0 -6.60815,2.77653 -3.10973,2.77654 -6.60816,7.55218 l 0,24.65564 q 1.61039,0.61084 3.94268,0.99955 2.38782,0.38872 4.83117,0.38872 3.22079,0 5.83073,-1.33274 2.66547,-1.33274 4.49799,-3.77609 1.88804,-2.44335 2.8876,-5.94178 0.99955,-3.55397 0.99955,-7.9409 z",
    style: {},
    id: "path4879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 345.9016,261.60594 q 0,4.83117 -2.1657,8.27408 -2.11017,3.38737 -5.66414,5.55307 -3.49843,2.11017 -7.99642,3.05419 -4.44246,0.99955 -9.10704,0.99955 -6.21944,0 -11.21721,-0.61084 -4.99776,-0.5553 -9.44022,-1.66592 l 0,-12.21676 q 5.21989,2.1657 10.38425,3.16525 5.21988,0.94403 9.82893,0.94403 5.33095,0 7.9409,-1.66593 2.66547,-1.72145 2.66547,-4.44245 0,-1.27721 -0.5553,-2.33229 -0.55531,-1.05509 -2.11017,-1.99911 -1.49933,-0.99955 -4.27587,-1.99911 -2.77653,-1.05508 -7.27452,-2.33229 -4.16481,-1.16614 -7.33006,-2.60994 -3.10972,-1.49933 -5.16435,-3.49844 -2.05464,-1.9991 -3.10973,-4.60905 -0.99955,-2.66547 -0.99955,-6.21944 0,-3.4429 1.55486,-6.49709 1.55486,-3.05419 4.60905,-5.33095 3.10972,-2.33229 7.71877,-3.66503 4.60905,-1.33274 10.77296,-1.33274 5.33095,0 9.44023,0.55531 4.10927,0.55531 7.27452,1.22168 l 0,11.05061 q -4.83117,-1.55486 -9.10704,-2.1657 -4.22033,-0.66637 -8.38514,-0.66637 -4.1648,0 -6.71921,1.49933 -2.49889,1.49933 -2.49889,4.16481 0,1.27721 0.49978,2.27676 0.49978,0.99955 1.94357,1.94357 1.49933,0.94403 4.10928,1.99911 2.66547,0.99955 6.99687,2.22123 4.8867,1.38827 8.21855,2.99866 3.33184,1.55486 5.33095,3.55396 2.05463,1.99911 2.94312,4.55352 0.8885,2.55442 0.8885,5.83073 z",
    style: {},
    id: "path4881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 391.38126,255.66415 -11.60592,0 -2.05464,-55.91944 15.7152,0 -2.05464,55.91944 z m -5.83073,6.4971 q 1.77699,0 3.33185,0.66636 1.61039,0.66637 2.77653,1.83252 1.16615,1.16614 1.83252,2.77653 0.7219,1.55487 0.7219,3.38738 0,1.83251 -0.7219,3.4429 -0.66637,1.55486 -1.83252,2.72101 -1.16614,1.16614 -2.77653,1.83251 -1.55486,0.66637 -3.33185,0.66637 -1.77698,0 -3.38737,-0.66637 -1.55486,-0.66637 -2.72101,-1.83251 -1.16614,-1.16615 -1.83251,-2.72101 -0.66637,-1.61039 -0.66637,-3.4429 0,-1.83251 0.66637,-3.38738 0.66637,-1.61039 1.83251,-2.77653 1.16615,-1.16615 2.72101,-1.83252 1.61039,-0.66636 3.38737,-0.66636 z",
    style: {},
    id: "path4883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.34f5196e49142225f1c68402c3a72f56.svg";
export { ForwardRef as ReactComponent };